
import { Component, Input, OnInit, OnDestroy,  ChangeDetectorRef, Inject } from '@angular/core';
import { TrafficsService } from '../../../services/traffics.service';
import { CommonOffer } from '../../../models/offers/CommonOffer';
import { Router, NavigationExtras } from '@angular/router';
import { EncryptionService } from '../../../services/encyption.service';
import { ParamFilters } from '../../../models/filtermodels/ParamFilters';
import { VerifyResponse } from '../../../models/offers/VerifyResponse';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { AuthGuardService } from '../../../services/auth-guard.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from '../../../services/auth.service';
import { Customer } from '../../../models/customers/Customer';
import { OfferpackService } from '../../../services/offerpack.service';
import { HotelFiltersService } from '@app/services/hotelfilters.service';
import moment from 'moment';
import { AcvisService } from '@app/services/acvis.service';
import { DOCUMENT } from '@angular/common';
@Component({
    selector: 'clever-flugcard',
    templateUrl: './flugcard.component.html',
    styleUrls: ['./flugcard.component.scss'],
    standalone: false
})
export class FlugcardComponent implements OnInit, OnDestroy {
    protected unsubscribe$ = new Subject();
    @Input() tmp_offer: CommonOffer;
    @Input() mode: string;
    realparams: ParamFilters;
    booking: VerifyResponse;
    validated: boolean = false;
    bookable: boolean = false;
    loading: boolean = false;
    shareLoading: boolean = false;
    packloading: boolean = false;
    inOfferpack: boolean = false;
    alternatives: boolean = false;
    desktopTemplate: string = 'xl';
    headpng: string = '';
    kostenlosStorno: string = '';
    kostenlosStornoC: string = '';
    serviceCodeFS: string = '';
    currentCustomer: Customer;
    showFlex: boolean = false;

    start: string;
    end: string;
    extratoexecforshare: Function;

    constructor(
        protected trafficsService: TrafficsService,
        protected encservice: EncryptionService,
        protected guardService: AuthGuardService,
        protected authService: AuthService,
        protected acvisService: AcvisService,
        protected router: Router,
        protected offerpackService: OfferpackService,
        protected cdr: ChangeDetectorRef,
        protected hotelService: HotelFiltersService,
        @Inject(DOCUMENT) protected document: any,
        protected mediaObserver: BreakpointObserver) {
    }

    ngOnInit(): void {
        this.extratoexecforshare = this.insertForShare.bind(this);
        this.initData();
        this.initCustomer();
        this.initMedia();
        this.initFilters();
    }

    initCustomer(): void {
        this.authService.auth$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((customer: Customer) => {
            this.currentCustomer = customer;
        });
    }

    initMedia(): void {
        if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
            this.desktopTemplate = 'xs';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Small)) {
            this.desktopTemplate = 'sm';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
            this.desktopTemplate = 'md';
        }
        if (this.mediaObserver.isMatched(Breakpoints.Large)) {
            this.desktopTemplate = 'lg';
        }
        if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
            this.desktopTemplate = 'xl';
        }
        this.cdr.detectChanges();
    }

    initFilters(): void {
        this.hotelService.getfilters$.pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe(params => {
            if (params && JSON.stringify(params) !== JSON.stringify(this.realparams)) {
                this.start = params.reisezeitraumResult.start;
                this.end = params.reisezeitraumResult.end;
                this.realparams = JSON.parse(JSON.stringify(params));
                this.checkOffer();
            }
        });
    }

    initData(): void {
        this.initFlex();
        this.headpng = this.tmp_offer?.tourOperator?.png;
    }

    initFlex(): void {
        if (this.tmp_offer?.tourOperator?.code?.length > 0) {
            this.acvisService.request({ tourcodes: [this.tmp_offer?.tourOperator?.code] }, 'getoprspecflex').pipe(
                takeUntil(this.unsubscribe$)
            ).subscribe(ops => {
                if (ops?.tourOperatorList?.length > 0) {
                    this.checkFlex(ops.tourOperatorList);
                }
            });
        }
    }

    async checkFlex(tours) {
        if (tours?.length > 0) {
            const now = moment().format('YYYY-MM-DD');
            for (let i = 0; i < tours.length; i++) {
                if (
                    now >= moment(tours[i].toma?.bookinkzeitraumvon).format('YYYY-MM-DD') &&
                    (
                        now <= moment(tours[i].toma?.bookinkzeitraumbis).format('YYYY-MM-DD') ||
                        !tours[i].toma?.bookinkzeitraumbis
                    ) &&
                    this.start >= moment(tours[i].toma?.reisezeitraumvon).format('YYYY-MM-DD') &&
                    (
                        this.start <= moment(tours[i].toma?.reisezeitraumbis).format('YYYY-MM-DD') ||
                        !tours[i].toma?.bookinkzeitraumbis
                    )

                ) {
                    for (let a = 0; a < tours[i]?.toma?.actions.length; a++) {
                        if (tours[i]?.toma?.actions[a].travelType === this.realparams.productType ||
                            tours[i]?.toma?.actions[a].travelType === 'beides') {
                            this.showFlex = true;
                            this.kostenlosStorno = tours[i]?.toma?.actions[a].text;
                            if (tours[i]?.toma?.actions[a]?.flexType !== 'kostenlos') {
                                this.serviceCodeFS = 'OHNE RISIKO! Günstig stornieren';
                            } else {
                                this.serviceCodeFS = 'OHNE RISIKO! Kostenfreies Storno';
                            }
                            a = tours[i].toma.actions.length;
                            i = tours.length;
                        }
                    }
                }
            }
            this.cdr.detectChanges();
        }
    }

    addToOfferpackList(): void {
        this.packloading = true;
        const target = {
            result: this.booking
        };
        this.trafficsService.request(target, 'offers/insertOffer').pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((res) => {
            if (res?.newid?.length > 0) {
                this.booking.offerid = res.newid;
                this.offerpackService.addOffer({ offerid: this.booking.offerid, type: 'traffics' });
            }
            this.packloading = false;
            this.cdr.detectChanges();
        });
    }

    removeFromOfferpackList(): void {
        if (this.booking?.offerid?.length > 0) {
            this.inOfferpack = false;
            this.offerpackService.removeOffer(this.booking.offerid);
        }
    }

    async checkOffer() {
        if (this.tmp_offer.code) {
            this.loading = true;
            this.cdr.detectChanges();
            let childtrenages = '';
            for (let i = 0; i < this.realparams.reisendeResult?.children?.length; i++) {
                childtrenages += this.realparams.reisendeResult.children[i].age;
                if (i < this.realparams.reisendeResult.children.length - 1) {
                    childtrenages += ',';
                }
            }
            const target = {
                data: {
                    code: this.tmp_offer.code,
                    adults: this.realparams.reisendeResult?.adults,
                    children: childtrenages
                },
                mode: this.mode,
                realparams: this.realparams
            };
            this.trafficsService.request(target, 'offers/code').pipe(
                takeUntil(this.unsubscribe$)
            ).subscribe((res) => {
                this.validated = true;
                if (!res?.error) {
                    this.booking = res as VerifyResponse;
                    this.bookable = res.statusCode === 'OK';
                    if (this.bookable) {
                        if (this.booking?.commonOffer) {
                            this.tmp_offer = this.booking.commonOffer;
                            this.cdr.detectChanges();
                        }
                    }
                } else {
                    this.bookable = false;
                    this.cdr.detectChanges();
                }
                this.loading = false;
                this.cdr.detectChanges();
            });
        }
    }

    openAlternativs(): void {
        this.alternatives = !this.alternatives;
    }

    async insertAndGoToBooking() {
        const win = window.open('', '_blank')
        if (this.booking?.offerid?.length > 0) {
            this.goToBooking(win);
        } else {
            this.loading = true;
            const target = {
                result: this.booking
            };
            this.trafficsService.request(target, 'offers/insertOffer').pipe(
                takeUntil(this.unsubscribe$)
            ).subscribe((res) => {
                if (res?.newid?.length > 0) {
                    this.booking.offerid = res.newid;
                }
                this.loading = false;
                this.cdr.detectChanges();
                this.goToBooking(win);
            });
        }
    }

    async goToBooking(win) {
        if (this.booking?.offerid?.length > 0) {
            this.realparams.offerid = this.booking?.offerid;
            const navigationExtras: NavigationExtras = {
                queryParams: { params: this.encservice.encrypt(this.realparams) }
            };
            const url = this.router.serializeUrl(
                this.router.createUrlTree(['booking'], navigationExtras)
            );
            win.location = url;
        }
    }

    insertForShare(cb): void {
        this.shareLoading = true;
        const target = {
            result: this.booking
        };
        this.trafficsService.request(target, 'offers/insertOffer').pipe(
            takeUntil(this.unsubscribe$)
        ).subscribe((res) => {
            if (res?.newid?.length > 0) {
                this.booking.offerid = res.newid;
                this.createSharelink(cb);
            }
            this.shareLoading = false;
            this.cdr.detectChanges();
        });
    }

    createSharelink(cb): void {
        this.realparams.offerid = this.booking?.offerid;
        cb(this.router.createUrlTree(['booking'], { queryParams: { params: this.encservice.encrypt(this.realparams) } }).toString());
    }

    
    ngOnDestroy(): void {
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }
}
